import { render, staticRenderFns } from "./Ui.vue?vue&type=template&id=05b6e838&"
import script from "./Ui.vue?vue&type=script&lang=js&"
export * from "./Ui.vue?vue&type=script&lang=js&"
import style0 from "./Ui.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports